export default (data: number[]) => data.reduce((a, b) => a + b) / data.length
